import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * `Membership` — PK composite `(userId, teamId)` (M22) : pas de colonne `id`, pas
 * d'historique de composition d'équipe. Les règles de service (deux membres par équipe,
 * seuls les rôles `agent`/`team` y entrent) sont posées en M12 — ce schéma ne porte que la
 * forme des données, pas ces contraintes de service.
 */
export const membershipSchema = z.object({
    userId: uuidV7Schema,
    teamId: uuidV7Schema,
});
//# sourceMappingURL=membership.js.map